
import { defineComponent, ref } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.js";

import { hideModal } from "@/core/helpers/dom";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "merchant-monday-modal",
  components: {},
  setup(props, context) {
    const formRef = ref<null | HTMLFormElement>(null);
    const mondayModalRef = ref<null | HTMLElement>(null);
    const loading = ref<boolean>(false);
    const formData = ref({
      apiKey: "keyFwSX22u1JHqp7I",
      boardId: "appZUqCkAbWrNnrXm",
    });

    const rules = ref({
      apiKey: [
        {
          required: true,
          message: "API key is required",
          trigger: "change",
        },
      ],
      boardId: [
        {
          required: true,
          message: "Board Id is required",
          trigger: "change",
        },
      ],
    });

    const submitValid = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate(async (valid) => {
        if (valid) {
          loading.value = true;

          try {
            const payload: any = {
              monday_api_key: formData.value.apiKey,
              monday_board_id: formData.value.boardId,
            };
            let res = await ApiService.post(
              `merchants/accounts?action=monday_sheets`,
              payload
            );

            if (res.data.success) {
              const header = res.data.data[0].column_values.map(
                (ele) => ele.id
              );
              const body = res.data.data.map((ele) => {
                const row = ele.column_values.map((col) => col.text);
                return row;
              });
              const values = [header, ...body];
              context.emit("on-handle-completed", values);
              hideModal(mondayModalRef.value);
            } else {
              Swal.fire({
                text: "Sorry, looks like there are some errors detected, please try again.",
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Ok, got it!",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              });
            }
          } catch (error) {
            Swal.fire({
              text: "Sorry, looks like there are some errors detected, please try again.",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary",
              },
            });
          }

          loading.value = false;
        } else {
          Swal.fire({
            text: "Sorry, looks like there are some errors detected, please try again.",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return false;
        }
      });
    };

    return {
      formData,
      rules,
      formRef,
      loading,
      mondayModalRef,
      submitValid,
    };
  },
});
